import {
  faPhotoFilm,
  faWandMagicSparkles,
  faPeopleGroup,
  faUserCheck,
} from '@fortawesome/free-solid-svg-icons';

export const Servicedata = [
  {
    id: 1,
    img: '/assets/images/icons/multimedia.png',
    Icon: faPhotoFilm,
    title: 'Engaging Multimedia Transformation',
    content:
      'Transform school standards into captivating music, video, and quiz/game formats, enhancing retention and making learning enjoyable.',
  },
  {
    id: 2,
    img: '/assets/images/icons/creativity.png',
    Icon: faWandMagicSparkles,
    title: 'Interactive Learning For Creativity',
    content:
      'Foster creativity with interactive tools that encourage students to explore and innovate.',
  },
];

export const Servicedata1 = [
  {
    id: 1,
    img: '/assets/images/icons/collaborative.png',
    Icon: faPeopleGroup,
    title: 'Collaborative Dynamics',
    content:
      'Promote teamwork and essential social skills with dynamic, participatory activities.',
  },
  {
    id: 2,
    img: '/assets/images/icons/personalized.png',
    Icon: faUserCheck,
    title: 'Personalized Learning Precision',
    content:
      'Enable personalized learning with real-time feedback, adapting to individual styles and enhancing understanding.',
  },
];
